import historicalSales from './historicalSales.csv';
import inventoryUsage from './inventoryUsage.csv';

export default {
  historicalSales,
  inventoryUsage,
};

export { historicalSales, inventoryUsage };
